import { db } from '@/firebase';
const diagnostic_proposals_ref = db.collection('diagnostic_proposals');

const createDiagnostic = async data => {
  try {
    const get_data = await diagnostic_proposals_ref.add(data);
    await editWaterScanProposal(get_data.id, { ...data, id_doc: get_data.id });
    return get_data.id;
  } catch (error) {
    throw new Error('createDiagnostic Fail!' + error);
  }
};

const createProposal = async data => {
  try {
    const get_data = await diagnostic_proposals_ref.add(data);
    await editProposal(get_data.id, { ...data, id_doc: get_data.id });
    return get_data.id;
  } catch (error) {
    throw new Error('createProposal Fail!' + error);
  }
};
const editWaterScanProposal = async (idDoc, data) => {
  try {
    await diagnostic_proposals_ref.doc(idDoc).update(data);
    return true;
  } catch (error) {
    throw new Error('editWaterScanProposal Fail!' + error);
  }
};

const editProposal = async (idDoc, data) => {
  try {
    await diagnostic_proposals_ref.doc(idDoc).update(data);
    return true;
  } catch (error) {
    throw new Error('editProposal Fail!' + error);
  }
};

const acceptProposal = async (idDoc) => {
  try {
    await diagnostic_proposals_ref.doc(idDoc).update({
      status: 'accepted',
      acceptedAt: new Date()
    });
    return true;
  } catch (error) {
    throw new Error('acceptProposal Fail!' + error);
  }
};
async function getWaterScanProposal() {
  let leads_list = [];
  try {
    const unitsRef = await diagnostic_proposals_ref.get();
    unitsRef.forEach(doc => leads_list.push(doc.data()));
    return leads_list;
  } catch (error) {
    console.error(error);
  }
}

async function getProposalById(proposalId) {
  try {
    const proposal = await diagnostic_proposals_ref.doc(proposalId).get();

    if (!proposal) {
      throw new Error('Proposal not found!');
    }

    return proposal.data();
  } catch (error) {
    console.error(error);
  }
}

async function getWaterScanProposalByDiagnosticId(idDiagnostic) {
  let leads_list = [];
  try {
    const result = await diagnostic_proposals_ref.where('id_diagnostic', '==', idDiagnostic).get();
    result.forEach(doc => leads_list.push(doc.data()));
    return leads_list;
  } catch (error) {
    console.error(error);
  }
}
async function getApprovedProposalByDiagnosticId(idDiagnostic) {
  let leads_list = [];
  try {
    const result = await diagnostic_proposals_ref
      .where('id_diagnostic', '==', idDiagnostic)
      .where('revision.status', '==', 'approved')
      .get();
    result.forEach(doc => leads_list.push(doc.data()));
    return leads_list;
  } catch (error) {
    console.error(error);
  }
}
async function getLastProposalByDiagnosticId(idDiagnostic) {
  let leads_list = [];
  try {
    const result = await diagnostic_proposals_ref
      .where('id_diagnostic', '==', idDiagnostic)
      .orderBy('createdAt', 'desc')
      .limit(1)
      .get();
    result.forEach(doc => leads_list.push(doc.data()));
    return leads_list;
  } catch (error) {
    console.error(error);
  }
}

async function getProposalsByFranchiseeIdAndLeadId(idFranchisee, idLead) {
  let leads_list = [];
  try {
    const result = await diagnostic_proposals_ref
      .where('id_franchisee', '==', idFranchisee)
      .where('id_lead', '==', idLead)
      .get();
    result.forEach(doc => leads_list.push(doc.data()));
    return leads_list;
  } catch (error) {
    console.error(error);
  }
}

async function getProposalsByLeadId(idLead) {
  let leads_list = [];
  try {
    const result = await diagnostic_proposals_ref
      .where('id_lead', '==', idLead)
      .get();
    result.forEach(doc => leads_list.push(doc.data()));
    return leads_list;
  } catch (error) {
    console.error(error);
  }
}

export default {
  createDiagnostic,
  createProposal,
  getWaterScanProposal,
  editWaterScanProposal,
  editProposal,
  acceptProposal,
  getLastProposalByDiagnosticId,
  getApprovedProposalByDiagnosticId,
  getWaterScanProposalByDiagnosticId,
  getProposalById,
  getProposalsByFranchiseeIdAndLeadId,
  getProposalsByLeadId,
};
